import React from "react";

const DashboardSidebar = () => {
  return (
    <div className="w-full xl:w-[294px] flex-[0_0_294px] space-y-5 ml-auto">
      <div className="bg-secondary-950 py-[20px] px-[15px] rounded-[20px] text-white">
        <h3 className="web-h5 text-center mb-2">Schedule Consultation</h3>
        <p className="text-sm text-center web-body-md mb-6">
          Book a consultation with an astrologer.
        </p>

        <button type="button" className="custom-btn custom-btn-primary w-full">
          Book Now
        </button>
      </div>

      <div className="bg-primary-50 p-[20px] rounded-[20px] text-[#252525] text-center">
        <div className="w-[80px] h-[80px] mx-auto mb-4 flex items-center justify-center">
          <img
            src="/images/tarot_icon.svg"
            alt="Tarot Card Icon"
            className="w-full h-full object-contain"
          />
        </div>

        <h3 className="web-h5 text-center text-gray-950 mb-2">
          Book Your Tarot Video Session
        </h3>
        <p className="web-body-md text-center text-gray-500">
          Discover love, career, and life insights with a personalized tarot
          consultation.
        </p>
      </div>

      {/* Add more sidebar content here if needed */}
    </div>
  );
};

export default DashboardSidebar;
